import { EditFilled } from '@ant-design/icons';
import { ReactNode } from 'react';

import { ShiftListItemDto } from '@clh/api-client';
import { STANDARD_MEAL_BREAK_MINUTES } from '@clh/util';

import { LogTime } from './log-time';
import { TimeWorkedSummary } from './time-worked-summary';

export const createSubmittedTimeFieldRenderer = (
    selection: ShiftListItemDto,
    isEditing: boolean,
    onEdit: () => void,
    onClose: () => void
): ((minutes?: number) => ReactNode) => {
    const renderSubmittedTime = (minutes?: number) => {
        const netWorkedMinutes = minutes ?? 0;
        const tookMealBreak =
            selection.skippedMealBreak !== null
                ? !selection.skippedMealBreak
                : false;
        // shift.minutesWorked is NET (meal break already subtracted).
        // TimeWorkedSummary expects GROSS hours and subtracts meal break itself,
        // so we add it back here to avoid double subtraction.
        const mealBreakMinutes = tookMealBreak
            ? STANDARD_MEAL_BREAK_MINUTES
            : 0;
        const worked = (netWorkedMinutes + mealBreakMinutes) / 60;
        const onCall = selection.onCallShift?.minutesWorked
            ? selection.onCallShift.minutesWorked / 60
            : 0;

        return (
            <div>
                {selection.nurseProfile && !isEditing ? (
                    <>
                        <a onClick={onEdit}>
                            {minutes ? (
                                <>
                                    Edit Time <EditFilled />
                                </>
                            ) : (
                                'Submit Time'
                            )}
                        </a>
                        {selection.didNotWork && <em> Did not work</em>}
                    </>
                ) : null}

                {isEditing && <LogTime close={onClose} />}

                {!!minutes && !isEditing && (
                    <>
                        <br />
                        <TimeWorkedSummary
                            didNotWork={selection.didNotWork}
                            worked={worked}
                            onCall={onCall}
                            tookMealBreak={tookMealBreak}
                        />
                    </>
                )}
            </div>
        );
    };

    renderSubmittedTime.displayName = 'SubmittedTimeFieldRenderer';
    return renderSubmittedTime;
};
